import { useEffect, useState } from 'react';
import { api, type VoiceSample } from '@/lib/api';
import styles from './SamplesPlayer.module.css';

export default function SamplesPlayer({ voiceId }: { voiceId: string }) {
  const [samples, setSamples] = useState<VoiceSample[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    api
      .listAiVoiceSamples(voiceId)
      .then((list) => {
        if (!cancelled) setSamples(list);
      })
      .catch((e) => {
        if (!cancelled)
          setError(e instanceof Error ? e.message : String(e));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [voiceId]);

  if (loading)
    return <div className={styles.status}>Lade Samples…</div>;
  if (error)
    return <div className={styles.error}>Fehler: {error}</div>;
  if (samples.length === 0)
    return (
      <div className={styles.status}>
        Keine Samples für diese Voice im WebDAV-Ordner gefunden.
      </div>
    );

  return (
    <div className={styles.wrap}>
      {samples.map((s) => (
        <div key={s.filename} className={styles.item}>
          <span className={styles.filename}>{s.filename}</span>
          <audio
            className={styles.audio}
            controls
            preload="none"
            src={s.url}
          />
        </div>
      ))}
    </div>
  );
}
